import { toNumber } from 'ng-zorro-antd/core/util';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { AllDocument } from './../record-model';
import { LayoutService } from 'src/app/layout/layout.service';
import { Relation } from 'src/app/layout/record-model';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { tap, switchMap, take } from 'rxjs/operators';
import {
  NzGraphComponent,
  NzGraphData,
  NzGraphDataDef,
  NzGraphEdgeDef,
  NzGraphNodeDef,
  NzGraphZoomDirective,
  NzRankDirection,
} from 'ng-zorro-antd/graph';
import { RecordPageComponent } from '../record-page/record-page.component';
import * as g from '@app/globals';
import { Area } from '@app/models/UserIdentity';
@Component({
  selector: 'app-relation-map',
  templateUrl: './relation-map.component.html',
  styleUrls: ['./relation-map.component.less'],
})
export class RelationMapComponent implements OnInit {
  @Input() recordId: any;
  @Input() moduleId: any;
  isLoading = false;
  objectType: any;
  view = [];
  layout = {
    label: 'Dagre',
    value: 'dagre',
  };
  relations: Relation[];
  AllDocuments: AllDocument[];
  nodes: NzGraphNodeDef[] = [];
  edges: NzGraphEdgeDef[] = [];
  rankDirection: NzRankDirection = 'LR';
  testDef: NzGraphDataDef = {
    nodes: this.nodes,
    edges: this.edges,
  };
  graphData = new NzGraphData(this.testDef);
  @ViewChild(NzGraphComponent, { static: true })
  nzGraphComponent!: NzGraphComponent;
  @ViewChild(NzGraphZoomDirective, { static: true })
  zoomController!: NzGraphZoomDirective;
  zoom = 0.5;

  avoidClickingRm = false;
  displayFullMap: boolean = false;

  constructor(
    private layoutService: LayoutService,
    private drawerService: NzDrawerService
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.layoutService
      .getModuleStructure(this.moduleId)
      .pipe(
        tap((result) => {
          this.objectType = result.module.ObjectTypeValue;
        }),
        switchMap(() =>
          this.layoutService.getDocumentRelations(
            this.recordId,
            this.objectType,
            false
          )
        ),
        tap((data: any) => {
          this.AllDocuments = data.Resault_Value.AllDocuments;
          this.relations = data.Resault_Value.Relations;
          this.documetnsToNodes();
          this.relationsToLinks();
          console.log(this.AllDocuments);
          console.log(this.relations);
          this.graphData = new NzGraphData(this.testDef);
          this.isLoading = false;
        })
      )
      .subscribe();

    this.layoutService
      .getConfiguration('config_CP_avoid_clicking_rm')
      .pipe(
        tap((response: string) => {
          this.avoidClickingRm = response === 'Y';
        })
      )
      .subscribe();
  }
  documetnsToNodes() {
    this.AllDocuments.forEach((document) => {
      const node: NzGraphNodeDef = {
        id: document.Id.toString(),
        label: document.Value.ObjectDescription,
        DocName: document.Value.ObjectDescription,
        DocNum: document.Value.DocNum.toString(),
        DocEntry: document.Value.DocEntry.toString(),
        DocTotal: document.Value.DocTotal,
        DocDate: document.Value.DocDate,
        DocCurrency: document.Value.DocCurrency,
        DocStatus: document.Value.DocStatus,
        IsMain: document.Value.IsMainDocument,
        ObjectType: document.Value.ObjType,
        IsIns: document.Value.IsIns,
        CANCELED: document.Value.CANCELED,
      };
      this.nodes = [...this.nodes, node];
    });
    this.testDef.nodes = this.nodes;
  }
  relationsToLinks() {
    this.relations.forEach((relation) => {
      const edge: NzGraphEdgeDef = {
        v: relation.from.toString(),
        w: relation.to.toString(),
      };
      this.edges = [...this.edges, edge];
    });
    this.testDef.edges = this.edges;
  }

  focusNode(node: any): void {
    const area = g.userIdentity.Area;
    let moduleApp = '';
    switch (area) {
      case Area.B1User:
        moduleApp = 'itm-crm';
        break;
      case Area.CustomerPortal:
        moduleApp = 'itm-external-cp';
        if (this.avoidClickingRm) {
          return;
        }
        break;
      case Area.SupplierPortal:
        moduleApp = 'itm-external-sp';
        if (this.avoidClickingRm) {
          return;
        }
        break;
      default:
        break;
    }
    this.layoutService
      .moduleIdByType(node.ObjectType, moduleApp)
      .pipe(
        tap((moduleId: number | string) => {
          RecordPageComponent.openRecordPage(this.drawerService, {
            actionType: 'View',
            drawerTitle: `${node.DocName} - ${node.DocNum}`,
            inDrawer: true,
            moduleId:
              node.ObjectType === 13 && node.IsIns === 'Y'
                ? 50019
                : toNumber(moduleId),
            parentComponent: this,
            recordId: node.DocEntry,
            recordModel: undefined,
          });
        })
      )
      .subscribe();
  }

  graphInitialized(ele: NzGraphComponent): void {
    this.zoomController?.fitCenter();
  }

  onDisplayFullMapChange(value: boolean): void {
    this.relations = [];
    this.AllDocuments = [];
    this.nodes = [];
    this.edges = [];
    this.testDef = {
      nodes: this.nodes,
      edges: this.edges,
    };
    this.graphData = new NzGraphData(this.testDef);

    console.log('Display Full Map toggled:', value);
    this.isLoading = true;

    this.layoutService
      .getDocumentRelations(this.recordId, this.objectType, value)
      .pipe(
        tap((data: any) => {
          this.AllDocuments = data.Resault_Value.AllDocuments;
          this.relations = data.Resault_Value.Relations;
          this.documetnsToNodes();
          this.relationsToLinks();
          console.log(this.AllDocuments);
          console.log(this.relations);
          this.graphData = new NzGraphData(this.testDef);
          this.isLoading = false;
        })
      )
      .subscribe();

    this.layoutService
      .getConfiguration('config_CP_avoid_clicking_rm')
      .pipe(
        tap((response: string) => {
          this.avoidClickingRm = response === 'Y';
        })
      )
      .subscribe();
  }
}
